export type RovoControlsSuppressedParams = {
	isAgentMentionActive: boolean;
	isSpecialistPromptInput: boolean;
};

/**
 * SINGLE SOURCE OF TRUTH for "a specialist agent owns this turn, so Rovo-owned
 * controls (reasoning mode, web search, app filters) do not apply."
 *
 * This predicate is the union of the two suppression conditions used across the
 * input, and is intentionally consumed by BOTH:
 *  - the submit payload (`getWebSearchEnabledForSubmit`, `getAppFiltersForSubmit`,
 *    `getSourceModeForSubmit`, and the reasoning-mode gating in
 *    `RovoChatPromptInput.handleSubmit`), and
 *  - the visible-state reset/restore effect (`rovoControlsSuppressed` in
 *    `RovoChatPromptInput`).
 *
 * Routing every check through here keeps the sent state and the shown state in
 * lock-step so they cannot drift. NOTE: individual submit fields may gate on a
 * SUBSET of this union (reasoning modes gate on `isSpecialistPromptInput` only;
 * web search / app filters gate on the full union). The reset effect resets the
 * union/superset, which is the desired UX (mentioning a specialist visibly
 * resets all Rovo controls).
 */
export const areRovoControlsSuppressed = ({
	isAgentMentionActive,
	isSpecialistPromptInput,
}: RovoControlsSuppressedParams): boolean => isAgentMentionActive || isSpecialistPromptInput;
